import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { BoxOpenComponent } from './box-open/box-open.component';
import { CustomerComponent } from './customer/customer.component';
import { LandingComponent } from './landing/landing.component';
import { PaymentInitComponent } from './payment-init/payment-init.component';

const routes: Routes = [
  { path: '', component: LandingComponent },
  { path: 'box-open/:sid', component: BoxOpenComponent },
  { path: 'customer/:sid', component: CustomerComponent },
  { path: 'payment-init/:sid', component: PaymentInitComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
